import { ResponseProductAttribute } from '@/data/types/Product';
import { validateStoreExclude } from '@/data/utils/validateStoreExclude';
import {
	MARKET_BUYABLE_EXCLUDE,
	STORE_BUYABLE_EXCLUDE,
	STORE_ONLY_AVAILABLE,
} from 'shared/custom/constants/commonConstants';

export const isValidBundleComponent = (
	component: Record<string, any>,
	marketId?: string,
	physicalStoreId?: string,
	{ skipInventoryCheck = false }: { skipInventoryCheck?: boolean } = {}
): boolean => {
	if (marketId && !skipInventoryCheck) {
		const inventoryQuantity = parseFloat(component?.[`inventories.M${marketId}.quantity`]);
		if (inventoryQuantity === 0) return false;
	}

	const exclusionRules: Record<string, string | undefined> = {
		[STORE_ONLY_AVAILABLE]: marketId,
		[MARKET_BUYABLE_EXCLUDE]: marketId,
		[STORE_BUYABLE_EXCLUDE]: physicalStoreId,
	};

	const attrs: ResponseProductAttribute[] = component.attributes ?? [];
	return !attrs.some((attr) => {
		const valueToCheck = exclusionRules[attr.identifier];
		return valueToCheck && validateStoreExclude(attr, valueToCheck);
	});
};
